module.exports = __webpack_public_path__ + "img/ic_band_step1.0601f6aa.png";